import { useContext, useMemo, useState } from "react"
import '../style/pages/investory.css';
import InvoiceCard from "../components/inverstoryPage/investoryCard";
import { config } from "../context/config";
import { action } from "../context/action";
import { dataa } from "../context/data";
import { switchh } from "../context/switch";
import { recodeNow, secondarySearch } from "../components/indexDB/indexDBStora";
import { collection } from "../context/collect";
import { intialData } from "../context/initial";
import { useTranslation } from "react-i18next";
import { auth } from "../context/auth";
export default function Investory() {
    const { stylingNav } = useContext(config);
    const { user } = useContext(auth);
    const { t } = useTranslation();
    const {errorMessage, setErrorMessage, successMessage, setSuccessMessage} = useContext(action);
    const { inventory, setInventory } = useContext(collection);
    const { initInventory } = useContext(intialData);
    const { investors, batches, products, suppliers } = useContext(dataa);
    const { loadingProcess, setLoadingProcess } = useContext(switchh);
    const [transactions, setTransactions] = useState([]);

    const CreateInvestory = async (e) => {
        e.preventDefault();
        
        setSuccessMessage("")
        setLoadingProcess(true);

        const findSameName = await secondarySearch("warehouse", "name", setInventory.name);
        
        if(findSameName.length !== 0) {
            setErrorMessage(t("error:investory.repeated"));
            setLoadingProcess(false);
            return;
        }
        if(!inventory.name || inventory.name.length > 20) {
            setErrorMessage(t("error:investory.moreChars"));
            setLoadingProcess(false);
            return;
        }
        setErrorMessage("");
        await recodeNow(inventory, "warehouse");
        setLoadingProcess(false);
        setInventory(initInventory);
    }
    

    const currency = user?.data[0]?.currency.code;

    const productsMap = useMemo(() => {
        return products?.reduce((acc, product) => {
            acc[product.id] = product.nameProudct;
            return acc;
        }, {}) || {};
    }, [products]);
    
    const suppliersMap = useMemo(() => {
        return suppliers?.reduce((acc, supp) => {
            acc[supp.id] = supp.supplierCompany;
            return acc;
        }, {}) || {};
    }, [suppliers]);

    const getTransactions = async (id) => {
        if(!id) return;
        const transactions = await secondarySearch("transactionBatch", "batchId", id);
        if(!transactions) return;
        setTransactions(transactions);
    }

    return (
        <div className={`investory page ${!stylingNav ? "page-grow" : "page-shrink"}`}>
            <div className="flex">
                <div className="half">
                    <h2 className="text-weight-light">{t("sections:investory.full")}</h2>
                    <form className="form-add" onSubmit={CreateInvestory}>
                        <label>{t("label:investory.label")}</label>
                        <input maxLength={20} onChange={(e) => setInventory((prev)=>({...prev, name: e.target.value}))} 
                        value={inventory.name} type="text" placeholder={t("placeholder:investory.writeInv")} />
                        <button disabled={loadingProcess}>{loadingProcess ? t("common:loading") : t("action:record")}</button>
                    </form>
                    <p className="error">{errorMessage}</p>
                    <p className="success">{successMessage}</p>
                    <div className="investory-box flex">
                        {investors?.map((item, key) => 
                            <InvoiceCard key={key} data={item} />
                        )}
                    </div>
                </div>
                <div className="transaction half">
                    <h3 className="center">المعاملات الحالية</h3>
                    <div className="table">
                        <table className="center">
                            <thead>
                                <tr>
                                    <th>الكمية</th>
                                    <th>من</th>
                                    <th>العملية</th>
                                    <th>الوقت</th>
                                </tr>
                            </thead>
                            <tbody className="table">
                                {transactions.length > 0 && transactions.map((transaction, key) => 
                                    <tr className="inp" key={key}>
                                        <td>{transaction.qty}</td>
                                        <td>{transaction.taker || "--"}</td>
                                        <td>{transaction.unit}</td>
                                        <td>{transaction.createdAt}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="table">
                <h3>{t("sections:investory.label")}</h3>
                <table className="center">
                    <thead>
                        <tr>
                            <th>{t("common:id")}</th>
                            <th>{t("label:investory.table.pricing.buy")}</th>
                            <th>{t("label:investory.table.product")}</th>
                            <th>{t("label:investory.table.supplier")}</th>
                            <th>{t("label:investory.table.reminder")}</th>
                            <th>{t("common:createdAt")}</th>
                            <th>{t("common:expirationAt")}</th>
                            <th>{t("common:action")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {batches?.length !== 0 ? (
                            batches.map((batch, index) => (
                            <tr className="inp" key={index}>
                                <td>{batch.name}</td>
                                <td>{batch.buyPrice} {currency}</td>
                                <td>{productsMap[batch.productId] || "-"}</td>
                                <td>{suppliersMap[batch.meta.supplierId] || "-"}</td>
                                <td>{batch.currentQty}</td>
                                <td>{batch?.meta?.createdAt || "--"}</td>
                                <td>{batch?.meta?.expiredDate || "--"}</td>
                                <td className="flex flex-center-center">
                                    <button onClick={() => getTransactions(batch.id)} className="text-weight-bold">{t("action:transactions")}</button>
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td className="no-data" colSpan={7}>
                                {t("common:notFound")}
                            </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {/* <Scroll /> */}
            </div>
        </div>
    )
}